<template>
    <div id="app" :style="{'width':innerWidth+'px'}">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App',
        provide() {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isRouterAlive: true,
                spinShow: true,
                innerWidth: window.innerWidth
            }
        },
        methods: {
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        },
        watch: {
        },
        mounted() {
            setTimeout(() => {
                this.spinShow = false
                this.innerWidth = window.innerWidth
            },1000)
        },
    }
</script>

<style>
    .ivu-layout{
    }
</style>



// WEBPACK FOOTER //
// src/App.vue